import type { FileItem, FileSubmissionEvaluator } from './types';

/**
 * Format file size for display
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

/**
 * Get artifact type display color
 */
export const getArtifactIconColor = (type?: string): 'primary' | 'secondary' | 'info' | 'action' | 'inherit' => {
  switch (type) {
    case 'binder':
      return 'primary';
    case 'k1_worksheets':
      return 'secondary';
    case 'supporting_doc':
      return 'info';
    case 'other':
      return 'action';
    default:
      return 'inherit';
  }
};

/**
 * Default file submission evaluator (placeholder)
 */
export const defaultFileSubmissionEvaluator: FileSubmissionEvaluator = (_file: FileItem) => {
  // Default implementation - could be enhanced based on actual submission logic
  return false;
};

/**
 * Create a tooltip with file information
 */
export const createFileTooltip = (
  file: FileItem,
  isSubmitted: boolean,
  showPreview: boolean
): string => {
  const parts = [
    file.contentType || 'Unknown file type',
    isSubmitted ? '(Submitted to SurePrep)' : '(Not yet submitted)',
  ];
  
  if (showPreview) {
    parts.push('• Click to preview');
  }
  
  return parts.join(' ');
};

/**
 * Determine if click should trigger preview
 */
export const shouldTriggerPreview = (
  event: React.MouseEvent,
  showPreview: boolean,
  isDeleting: boolean
): boolean => {
  // Don't trigger preview if clicking on action buttons
  if ((event.target as Element).closest('[data-action-button]')) {
    return false;
  }
  
  return showPreview && !isDeleting;
};

/**
 * Get hover styles for file items
 */
export const getFileItemHoverStyles = (showPreview: boolean, isDeleting: boolean) => {
  if (showPreview && !isDeleting) {
    return {
      cursor: 'pointer',
      '&:hover': {
        bgcolor: 'action.hover',
      },
    };
  }
  
  return {
    cursor: 'default',
  };
};